import axios from 'axios';
import keycloak from '../../keycloak';

const loadConfig = async () => {
  const response = await fetch('/config.json');
  const config = await response.json();
  const env = import.meta.env.PROD ? 'production' : 'development';
  return config[env];
};

const serverConfig = await loadConfig();

const TARGET_API_SERVER = serverConfig.TARGET_API_SERVER;
export const KEYCLOAK_SERVER = serverConfig.KEYCLOAK_SERVER;
export const KEYCLOAK_REALM = serverConfig.KEYCLOAK_REALM;
export const KEYCLOAK_CLIENT_ID = serverConfig.KEYCLOAK_CLIENT_ID;
const STAC_SERVER = serverConfig.STAC_SERVER;
export const PIXEL_SERVER = serverConfig.PIXEL_SERVER;
export const USE_KEYCLOAK = serverConfig.USE_KEYCLOAK;
export const PRIVATEER_REDIRECT_URL = serverConfig.PRIVATEER_REDIRECT_URL;

const axiosInstance = (baseURL) => axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    // Add any default headers here
  },
});

export const getAuthToken = (raw = false) => {
  if (!keycloak.token) return null;
  return raw ? keycloak.token : `Bearer ${keycloak.token}`;
};

const isTokenExpired = () => {
  const tokenExpiresAt = keycloak.tokenParsed?.exp * 1000;
  return Date.now() >= tokenExpiresAt - 30000;
};

const refreshToken = async () => {
  try {
    await keycloak.updateToken(30);
  } catch (error) {
    console.error('Failed to refresh token:', error);
    keycloak.logout();
    throw error;
  }
};

const ensureToken = async () => {
  if (isTokenExpired()) {
    await refreshToken();
  }
};

const apiService = {
  get: async (url, params, config = {}, isSTACServer) => {
    await ensureToken();
    const baseURL = isSTACServer ? STAC_SERVER : TARGET_API_SERVER;
    try {
      const instance = axiosInstance(baseURL);
      instance.defaults.headers.common['Authorization'] = getAuthToken();
      const response = await instance.get(url, { params, ...config });
      return response.data;
    } catch (error) {
      handleRequestError(error);
      throw error;
    }
  },
  post: async (url, data, config = {}, isSTACServer) => {
    await ensureToken();
    const baseURL = isSTACServer ? STAC_SERVER : TARGET_API_SERVER;
    try {
      const instance = axiosInstance(baseURL);
      instance.defaults.headers.common['Authorization'] = getAuthToken();
      const response = await instance.post(url, data, config);
      return response.data;
    } catch (error) {
      handleRequestError(error);
      throw error;
    }
  },
  put: async (url, data, config = {}, isSTACServer) => {
    await ensureToken();
    const baseURL = isSTACServer ? STAC_SERVER : TARGET_API_SERVER;
    try {
      const instance = axiosInstance(baseURL);
      instance.defaults.headers.common['Authorization'] = getAuthToken();
      const response = await instance.put(url, data, config);
      return response.data;
    } catch (error) {
      handleRequestError(error);
      throw error;
    }
  },
  delete: async (url, config = {}, isSTACServer) => {
    await ensureToken();
    const baseURL = isSTACServer ? STAC_SERVER : TARGET_API_SERVER;
    try {
      const instance = axiosInstance(baseURL);
      instance.defaults.headers.common['Authorization'] = getAuthToken();
      const response = await instance.delete(url, config);
      return response.data;
    } catch (error) {
      handleRequestError(error);
      throw error;
    }
  },
};

const handleRequestError = (error) => {
  // Add your error handling logic here
  console.error('Request failed:', error);
};

export default apiService;
